export default __webpack_public_path__ + "static/media/Service4.86cd34b1.jpg";